import { IssueType } from '../models/enums/issueType';


/**
 * This class contains functions that help map issue types from a third-party (i.e. jira) to our issueType-enum
 */

export class IssueTypeMappingUtil {
  constructor() { }

  public static mapFromJiraIssueTypeName(jiraIssueTypeName: string): IssueType {
    switch (jiraIssueTypeName) {
      case 'Epic': {
        return IssueType.EPIC;
      }
      case 'Story': {
        return IssueType.USERSTORY;
      }
      case 'Task': {
        return IssueType.TASK;
      }
      case 'Bug': {
        return IssueType.BUG;
      }
      case 'Sub-task': {
        return IssueType.SUBTASK;
      }
      default: {
        console.log('could not map issutype, using story-type as fallback');
        return IssueType.USERSTORY;
      }
    }
  }

  // Helper
  public static StringIsNumber = value => isNaN(Number(value)) === false;

  // TODO (DZ): missing param-type
  // Turn enum into JiraIssueType array
  public static mapToJiraIssueTypeMap(enumme): Map<string, string> {
    const arr =  Object.keys(enumme).filter(IssueTypeMappingUtil.StringIsNumber);
    return Object.assign({}, ...arr.map(idx => ({ [idx]: IssueTypeMappingUtil.mapToJiraIssueTypeName(Number(idx)) })));
  }

  public static mapToJiraIssueTypeName(issueType: number): string {
    switch (issueType) {
      case IssueType.EPIC: {
        return 'Epic';
      }
      case IssueType.USERSTORY: {
        return 'Story';
      }
      case IssueType.TASK: {
        return 'Task';
      }
      case IssueType.BUG: {
        return 'Bug';
      }
      case IssueType.SUBTASK: {
        return 'Sub-task';
      }
      default: {
        return 'DEFAULT';
      }
    }
  }



}
